/* eslint-disable no-extra-boolean-cast */
import Vue from 'vue'
import VueRouter from 'vue-router'

import Login from '../components/Login.vue'
import ChangePassword from "../components/ChangePassword"

import Login2 from "@/components/Login2";
import About from "@/components/About.vue";

import Dashboard from '../components/Dashboard.vue'

import HomeCustomer from '../components/HomeCustomer.vue'
import HomeEmployee from '../components/HomeEmployee.vue'
import HomeAdministration from '../components/HomeAdministration.vue'

import ChangeHistory from '../components/ChangeHistory.vue'
import PageAids from '../components/PageAids.vue'
import PageComingSoon from "../components/PageComingSoon.vue";
import AccessDenied from "@/components/AccessDenied.vue";
import Page404 from "@/components/Page404.vue";

import WarrantyRequestForm from '../components/WarrantyRequestForm.vue'
import OrderTracking from '../components/OrderTracking.vue';
import QuoteApproval from '../components/QuoteApproval.vue'
import UpdateDirectory from "../components/UpdateDirectory.vue"

// Componentes Optimo PAC
import ProductsList from '../components/file/ProductsList.vue'

import Sellers from '../components/file/Sellers/Sellers.vue'
import SellerDetail from '../components/file/Sellers/SellerDetail.vue'
import DirectoryEmployee from '../components/file/DirectoryEmployee/DirectoryEmployee.vue'
import DirectoryEmployeeItemView from '../components/file/DirectoryEmployee/DirectoryEmployeeItemView.vue'
import DirectoryEmployeeItemForm from '../components/file/DirectoryEmployee/DirectoryEmployeeItemForm.vue'
import Dependencies from '../components/file/Dependencies/Dependencies.vue'
import DependencyForm from '../components/file/Dependencies/DependencyForm.vue'
// import Quotes from '../components/movements/quotes/Quotes.vue'
import QuotesList from '../components/movements/quotes/QuotesList.vue'

// Componentes Optimo ConGA
import ProductsEmployee from '../modules/products/components/datagrids/ProductsList.vue'
import ProductForm from "../modules/products/components/forms/ProductForm.vue";

// Contratos de arrendamiento
import RentContracts from '@/modules/customers/components/datagrids/RentContracts.vue'
import RentContractForm from '@/modules/customers/components/forms/RentContractForm.vue'
import RentedProducts from '@/modules/customers/components/datagrids/RentedProducts.vue'
import RentedProductForm from '@/modules/customers/components/forms/RentedProductForm.vue'

// import ImportOrders from '../components/movements/ImportOrders.vue'
import OrderProcesses from '../components/movements/OrderProcesses.vue'
import Warranties from '../components/movements/warranties/Warranties.vue'
import WarrantyTracingForm from '../components/movements/warranties/WarrantyTracingForm.vue'
import OrdersList from '../components/movements/orders/OrdersList.vue'

import Orders from '../components/movements/Orders.vue'
import QuoteForm from "../components/movements/quotes/QuoteForm.vue";
import OrderCart from '../components/movements/OrderCart.vue'


// Menus
import CompanyMenu from "@/modules/company/CompanyMenu.vue";
import SalesMenu from "@/components/menus/SalesMenu.vue";
import ShoppingMenu from "@/components/menus/ShoppingMenu.vue";

// Componentes de empresa


// Componentes de Mercadeo
import MarketingMenu from "@/modules/marketing/components/MarketingMenu.vue";
import DashboardMarketing from "@/modules/marketing/components/DashboardMarketing.vue";
import DashboardPowerBI from "@/modules/marketing/components/DashboardPowerBI.vue";

import Campaigns from "@/modules/marketing/components/datagrids/CampaignsList.vue";
import CampaignForm from "@/modules/marketing/components/forms/CampaignForm.vue";
import CampaignsProducts from "@/components/datagrids/CampaignsProducts.vue";
import Prospects from "@/modules/marketing/components/datagrids/ProspectsList.vue";
import ProspectForm from "@/modules/marketing/components/forms/ProspectForm.vue";
import Opportunities from "@/modules/marketing/components/datagrids/OpportunitiesList.vue";
import OpportunityForm from "@/modules/marketing/components/forms/OpportunityForm.vue";
import CalendarActivities from "../modules/marketing/components/datagrids/CalendarActivities.vue";
import TrackingDocs from '../modules/marketing/components/datagrids/TrackingDocs.vue'

// Componentes de dashboards
import DashboardProducts from '../components/dashboards/DashboardProducts'
import DashboardCustomer from '../components/dashboards/DashboardCustomer'
import DashboardSales from '../components/dashboards/DashboardSales'
import DashboardSellers from '../components/dashboards/DashboardSellers'
import DashboardLogistics from "../modules/logistics/components/dashboards/DashboardLogistics.vue";


import SalesBudgetExecution from '../components/queries/SalesBudgetExecution.vue'
import DocumentSalesProfit from "../components/queries/DocumentSalesProfit"

import AccountStatus from '../components/queries/AccountStatus.vue'
import HistoricSales from '../components/queries/HistoricSales.vue'
import HistoricOrders from '../components/queries/HistoricOrders.vue'
import HistoricConsumptionOrders from '../components/queries/HistoricConsumptionOrders.vue'

import BudgetExecution from '../components/queries/BudgetExecution.vue'
// import BudgetExecutionEmployeeCategory from '../components/queries/BudgetExecutionEmployeeCategory.vue'
import PurchaseInvoices from '../components/queries/PurchaseInvoices.vue';
import SellBills from '../components/queries/SellBills.vue'
import WareDelivery from '../components/queries/WareDelivery.vue'
import DocumentsTrackingControl from '../components/queries/DocumentsTrackingControl.vue'

// Componentes de consultas
import AccountingMenu from "@/modules/queries/components/AccountingMenu.vue";
import DashboardEventsSalesInvoices from "@/modules/queries/components/DashboardEventsSalesInvoices.vue";
// import AccountingMenu from "@/components/menus/AccountingMenu.vue";

// Componentes de procesos
import InventoryProcess from "@/components/process/InventoryProcess";

import ReceptionElectronicDocuments from '../components/queries/ReceptionElectronicDocuments.vue'
import SupportingDocuments from "../components/queries/SupportingDocuments.vue";
import ElectronicDocuments from "../components/queries/ElectronicDocuments.vue"

// Componentes de empleados
import HumanResourceMenu from "@/modules/employees/components/HumanResourceMenu.vue";
import ElectronicPayrollList from "@/modules/employees/components/datagrids/ElectronicPayrollList.vue";


import Users from '../components/config/Users.vue'
import UsersManagement from "../components/config/UsersManagement"
import UserForm from "../components/config/UserForm"


Vue.use(VueRouter)

const routes = function(store) {
  return [
      { 
        path: "",
        beforeEnter(to, from, next){        
          if (store.state.user.isLoggedIn) {
            if (store.state.user.type == 'C') {
              next('/cliente')            
            } else {
              if (store.state.user.data.tipo_Empleado === "V") {
                next('/comercial');
              } else {
                next("/administracion");
              }
            }
          } else {
            next('/login')
          }
        }
      },
      {
        path: "/login",
        component: Login,
        beforeEnter(to, from, next) {
          if (store.state.user.isLoggedIn) {
            if (store.state.user.type == 'C') {
              next('/cliente');
            } else {
              if (store.state.user.data.tipo_Empleado === "V") {
                next("/comercial");
              } else {
                next("/administracion");
              }
            }
          } else {
            next();
          }
        }
      },
      {
        path: "/newlogin",
        component: Login2
      },
      { 
        path: '/cliente', 
        component: Dashboard,
        props: {
          fatherpath: 'cliente'
        },
        children: [
          { 
            path: '/',
            name: 'Inicio', 
            component: HomeCustomer
          },
          { 
            path: 'archivo',
            name: 'Archivo',
            component: {
              render (c) { return c('router-view') }
            },
            redirect: 'archivo/productos',
            children: [
              {
                path: 'productos',
                name: 'Productos',
                component: ProductsList
              },
              {
                path: 'dependencias',
                name: 'Dependencias',
                component: {
                  render (c) { return c('router-view') }
                },
                beforeEnter(to, from, next) {
                  store.state.user.data.tipo_Gestor === 'S' ? next() : next({ path: '/sinacceso' })
                },
                redirect: 'dependencias',
                children: [
                  { path: '/', component: Dependencies},
                  { path: 'agregar', name:'Agregar Dependencia', component: DependencyForm},
                  { path: 'editar', name:'Editar Dependencia', component: DependencyForm}
                ]
              }
            ]
          },
          { 
            path: 'movimientos',
            name: 'Movimientos', 
            component: {
              render (c) { return c('router-view') }
            },
            redirect: 'movimientos/pedidos',
            children: [
              { name: 'Pedidos', 
                path: 'pedidos',
                redirect: 'pedidos',
                component: {
                  render (c) { return c('router-view') }
                },
                children: [
                  { path: '/', component: Orders },
                  { name: 'Detalle Documento de Pedidos', path: 'detalleDocPedidos' },
                  { 
                    name: 'Procesamiento de Pedido', 
                    path: 'procesamientoPedido', 
                    component: OrderCart,
                    beforeEnter(to, from, next) {
                      store.state.cart.items.length ? next() : next({ path: '/cliente/movimientos/pedidos' })
                    },
                  }
                ]
              },
              // { name: 'Importación de pedidos', path: 'importacionPedidos', component: ImportOrders },
              { 
                name: 'Proceso Pedidos', 
                path: 'procesoPedidos', 
                component: OrderProcesses,
                beforeEnter(to, from, next) {
                  if (store.state.user.data.tipo_Gestor === "S" || store.state.user.data.tipo_Gestor === "A") {
                    next()
                  } else {
                    next({ path: "/sinacceso" })
                  }
                  // store.state.user.data.tipo_Gestor === 'A' ? next() : next({ path: '/sinacceso' })
                },
              }
            ]
          },
          { 
            path: 'consultas',
            name: 'Consultas', 
            component: {
              render (c) { return c('router-view') }
            },
            redirect: 'consultas/estadoCuenta',
            children: [
              { name: 'Estado de Cuenta', path: 'estadoCuenta', component: AccountStatus },
              { name: "Historial de Consumos Pedidos", path: 'historialConsumosPedidos', component: HistoricConsumptionOrders},
              { name: 'Historial de Compras', path: 'historicoCompras', component: HistoricSales },
              { name: 'Historial de Pedidos', path: 'historialPedidos', component: HistoricOrders },
              { name: 'Ejecución Presupuesto', path: 'ejecucionPresupuesto', component: BudgetExecution}
            ]
          },
          // { 
          //   path: 'reportes',
          //   name: 'Reportes', 
          //   redirect: 'reportes/historico',
          //   children: [
          //     { name: 'Historico de compras', path: 'historico' },
          //     { name: 'Top de Productos Comprados', path: 'topProductos' }
          //   ]
          // },
          { 
            path: 'configuracion',
            name: 'Configuración',
            component: {
              render (c) { return c('router-view') }
            },
            redirect: 'configuracion/usuariosCliente', 
            children: [
              {
                path: 'usuariosCliente',
                name: 'Usuarios',
                component: Users,
                beforeEnter(to, from, next) {
                  store.state.user.data.tipo_Gestor === 'S' ? next() : next({ path: '/sinacceso' })
                }
              }
            ]
          },
          {
            path: 'ayudas',
            name: 'Ayudas',
            component: PageAids
          }
        ],
        beforeEnter(to, from, next) {
          // Aqui se evalua para donde se redirige el flujo segun el usuario
          if (store.state.user.isLoggedIn) {
            if (store.state.user.type === 'C') {
              next()            
            } else {
              if (store.state.user.data.tipo_Empleado === "V") {
                next('/comercial');
              } else {
                next("/administracion");
              }
            }
          } else {
            next('/login')
          }
        }
      },
      {
        path: "/administracion",
        component: Dashboard, //Este es el componente principal que se deberia cambiar si se requiere de otro menu general.
        props: {
          fatherpath: "administracion"
        },
        redirect: to => redirect2(to, store),
        children: [
          {
            path: "/",
            name: "Dashboard Administracion",
            component: HomeAdministration
          },
          {
            path: "coming-soon",
            name: "Proximamente!",
            component: PageComingSoon
          },
          {
            path: "archivo",
            name: "Archivo",
            component: {
              render (c) { return c("router-view") }
            },
            children: [
              {
                path: "productos",
                name: "Productos",
                component: {
                  render (c) { return c("router-view") }
                },
                redirect: "productos",
                children: [
                  {
                    path: "/",
                    component: ProductsEmployee
                  },
                  {
                    path: "agregar",
                    name: "Agregar",
                    component: ProductForm
                  },
                  {
                    path: "editar",
                    name: "Editar",
                    component: ProductForm
                  }
                ]
              },
              {
                path: 'directorio',
                name: 'Directorio',
                component: {
                  render (c) { return c('router-view') }
                },
                redirect: 'directorio',
                children: [
                  {
                    path: '/',
                    component: DirectoryEmployee,
                  },
                  {
                    path: 'detalle',
                    name: 'Detalle',
                    component: DirectoryEmployeeItemView
                  },
                  {
                    path: 'agregar',
                    name: 'Agregar',
                    component: DirectoryEmployeeItemForm
                  },
                  {
                    path: 'editar',
                    name: 'Editar',
                    component: DirectoryEmployeeItemForm
                  },
                  {
                    path: 'agregarContacto',
                    name: 'Agregar Contacto',
                    component: DependencyForm
                  },
                  { 
                    path: 'editarContacto', 
                    name:'Editar Contacto', 
                    component: DependencyForm
                  }
                ]
              },
              {
                path: 'vendedores',
                name: 'Vendedores',
                component: {
                  render (c) { return c('router-view') }
                },
                redirect: 'vendedores',
                children: [
                  {
                    path: '/',
                    component: Sellers
                  },
                  {
                    path: 'detalle',
                    name: 'Detalle',
                    component: SellerDetail
                  }
                ]
              },
              {
                path: "empresa",
                name: "Empresa",
                component: CompanyMenu
              }
            ]
          },
          {
            path: "movimientos",
            name: "Movimientos",
            component: {
              render(c) {
                return c("router-view");
              }
            },
            children: [
              {
                path: "personal",
                name: "Personal",
                component: {
                  render(c) {
                    return c("router-view");
                  }
                },
                redirect: "personal",
                children: [
                  {
                    path: "/",
                    component: HumanResourceMenu
                  },
                  {
                    path: "nominaelectronica",
                    name: "Nomina Electronica",
                    component: ElectronicPayrollList
                  }
                ]
              },
              {
                path: "mercadeo",
                name: "Mercadeo",
                component: {
                  render(c) {
                    return c("router-view")
                  }
                },
                redirect: "mercadeo",
                children: [
                  {
                    path: "/",
                    component: MarketingMenu
                  },
                  {
                    path: "campanias",
                    name: "Campañas",
                    component: {
                      render(c) {
                        return c("router-view")
                      }
                    },
                    redirect: "campanias",
                    children: [
                      {
                        path: "/",
                        component: Campaigns
                      },
                      {
                        path: "agregar",
                        name: "Agregar Campaña",
                        component: CampaignForm
                      },
                      {
                        path: "editar/:id",
                        name: "Editar Campaña",
                        component: CampaignForm
                      },
                      {
                        path: "productoscampanias",
                        name: "Productos Campañas",
                        component: CampaignsProducts
                      }
                    ]
                  },
                  {
                    path: "prospectos",
                    name: "Prospectos",
                    component: {
                      render (c) {
                        return c("router-view");
                      }
                    },
                    redirect: "prospectos",
                    children: [
                      {
                        path: "/",
                        component: Prospects
                      },
                      {
                        path: "agregar",
                        name: "Agregar Prospecto",
                        component: ProspectForm
                      },
                      {
                        path: "editar/:id",
                        name: "Editar Prospecto",
                        component: ProspectForm
                      }
                    ]
                  },
                  {
                    path: "oportunidades",
                    name: "Oportunidades",
                    component: {
                      render (c) {
                        return c("router-view");
                      }
                    },
                    redirect: "oportunidades",
                    children: [
                      {
                        path: "/",
                        component: Opportunities
                      },
                      {
                        path: "agregar",
                        name: "Agregar Oportunidad",
                        component: OpportunityForm
                      }
                    ]
                  },
                  {
                    path: "seguimientos",
                    name: "Seguimientos",
                    component: TrackingDocs
                  },
                  {
                    path: "calendarioactividades",
                    name: "Calendario Actividades",
                    component: CalendarActivities
                  }
                ]
              },
              {
                path: "clientes",
                name: "Clientes",
                component: {
                  render (c) { 
                    return c("router-view");
                  }
                },
                redirect: "clientes",
                children: [
                  {
                    path: "/",
                    component: SalesMenu
                  },
                  {
                    path: "cotizaciones",
                    name: "Cotizaciones",
                    component: {
                      render (c) { 
                        return c("router-view");
                      }
                    },
                    redirect: "cotizaciones",
                    children: [
                      {
                        path: "/",
                        component: QuotesList
                      },
                      {
                        path: "agregar",
                        name: "Agregar Cotizacion",
                        component: QuoteForm
                      },
                      {
                        path: "editar",
                        name: "Editar Cotizacion",
                        component: QuoteForm
                      }
                    ]
                  },
                  {
                    path: "pedidos",
                    name: "Pedidos",
                    component: OrdersList
                  },
                  {
                    path: "entregasmercancia",
                    name: "Entregas de Mercancia",
                    component: WareDelivery
                  },
                  {
                    path: "facturasventa",
                    name: "Facturas de Venta",
                    component: SellBills
                  },
                  {
                    path: "contratosarrendamientos",
                    name: "Contratos de Arrendamientos",
                    component: {
                      render(c) {
                        return c("router-view")
                      }
                    },
                    redirect: "contratosarrendamientos",
                    children: [
                      {
                        path: "/",
                        component: RentContracts
                      },
                      { 
                        path: "agregar",
                        name:"Agrega Contrato de Arrendamiento", 
                        component: RentContractForm
                      },
                      { 
                        path: "editar/:id",
                        name:"Edita Contrato de Arrendamiento", 
                        component: RentContractForm
                      },
                      { 
                        path: ":id",
                        component: {
                          render(c) { 
                            return c("router-view");
                          }
                        },
                        redirect: "movimientos/clientes/contratosarrendamientos/:id/productosarrendamientos",
                        children: [
                          {
                            path: "productosarrendamientos",
                            name:"Productos Arrendamientos",
                            component: {
                              render(c) { 
                                return c("router-view");
                              }
                            },
                            redirect: "productosarrendamientos",
                            children: [
                              { 
                                path: "/", 
                                component: RentedProducts 
                              },
                              { 
                                path: "agregar", 
                                name:"Agregar Producto Arrendamiento", 
                                component: RentedProductForm 
                              },
                              { 
                                path: "editar/:rentedProductId", 
                                name:"Editar Producto Arrendamiento", 
                                component: RentedProductForm 
                              },
                            ] 
                          }
                        ]
                      }
                    ]

                  },
                  {
                    path: "garantias",
                    name: "Garantías",
                    component: Warranties
                  },
                  {
                    path: "controlseguimientodocumentos",
                    name: "Seguimiento de Entregas",
                    component: DocumentsTrackingControl
                  },
                  {
                    path: "controldocumentoselectronicosventa",
                    name: "Documentos Electronicos de Venta",
                    component: ElectronicDocuments
                  }
                ]
              },
              {
                path: "proveedores",
                name: "Proveedores",
                component: {
                  render (c) { 
                    return c("router-view");
                  }
                },
                redirect: "proveedores",
                children: [
                  {
                    path: "/",
                    component: ShoppingMenu
                  },
                  {
                    path: "facturascompra",
                    name: "Facturas de Compra",
                    component: PurchaseInvoices
                  },
                  {
                    path: "documentossoporte",
                    name: "Documentos Soporte",
                    component: SupportingDocuments
                  },
                  {
                    path: "recepciondocumentoselectronicos",
                    name: "Recepcion de Documentos Electronicos",
                    component: ReceptionElectronicDocuments
                  }
                ]
              }
            ]
          },
          {
            path: "consultas",
            name: "Consultas",
            component: {
              render (c) { return c("router-view") }
            },
            redirect: to => redirect2(to, store),
            children: [
              {
                path: "contables",
                name: "Contables",
                component: {
                  render (c) { return c("router-view") }
                },
                redirect: "contables",
                children: [
                  {
                    path: "/",
                    component: AccountingMenu
                  },
                  {
                    path: "eventosfacturasventa",
                    name: "Eventos Facturas de Venta",
                    component: DashboardEventsSalesInvoices
                  }
                ]
              },
            ]
          },
          {
            path: "procesos",
            name: "Procesos",
            component: {
              render (c) { return c("router-view") }
            },
            children: [
              {
                path: "inventarios",
                name: "Inventarios",
                component: InventoryProcess
              }
            ]
          },
          {
            path: 'indicadores',
            name: 'Indicadores',
            component: {
              render (c) { return c('router-view') }
            },
            redirect: to => redirect2(to, store),
            children: [
              {
                path: "dashboardproductos",
                name: "Dashboard de Productos",
                component: DashboardProducts
              },
              {
                path: "dashboardclientes",
                name: "Dashboard de Clientes",
                component: DashboardCustomer
              },
              {
                path: "dashboardventas",
                name: "Dashboard de Ventas",
                component: {
                  render(c) { return c("router-view") }
                },
                redirect: "dashboardventas",
                children: [
                  {
                    path: "/",
                    component: DashboardSales
                  },
                  {
                    path: "utilidadventasdocumentos",
                    name: "Utilidad de Ventas por Documentos",
                    component: DocumentSalesProfit
                  },
                  {
                    path: 'ejecucionpresupuestoscategorias',
                    name: 'Ejecución Presupuestos Ventas Categorias',
                    component: SalesBudgetExecution,
                    beforeEnter(to, from, next) {
                      if (store.state.user.data.tipo_Empleado === 'A' || store.state.user.data.tipo_Empleado === 'D') {
                        next()            
                      } else {
                        next({ path: "/sinacceso" });
                      }
                    }
                  }
                ]
              },
              {
                path: "dashboardcomerciales",
                name: "Dashboard de Comerciales",
                component: DashboardSellers
              },
              {
                path: "dashboardmercadeo",
                name: "Dashboard de Mercadeo",
                component: DashboardMarketing
              },
              {
                path: "dashboardpowerbi",
                name: "Dashboard PowerBI",
                component: DashboardPowerBI
              }
            ]
          },
          {
            path: "ayudas",
            name: "Ayudas",
            component: {
              render (c) { return c("router-view") }
            },
            redirect: to => redirect2(to, store),
            children: [
              {
                path: 'repositorioarchivos',
                name: 'Repositorio de Archivos'
              },
              {
                path: 'historialcambios',
                name: 'Historial de Cambios',
                component: ChangeHistory
              },
              {
                path: "acerca",
                name: "Acerca de ...",
                component: {
                  render(c) { return c("router-view") }
                },
                redirect: to => redirect2(to, store),
                children: [
                  {
                    path: "/",
                    component: About
                  },
                  {
                    path: "usuarios",
                    name: "Usuarios del Sistema",
                    component: {
                      render(c) { return c("router-view") }
                    },
                    children: [
                      {
                        path: "/",
                        component: UsersManagement
                      },
                      {
                        path: "agregar",
                        name: "Formulario de Usuario - [Agregando]",
                        component: UserForm
                      },
                      {
                        path: "editar",
                        name: "Formulario de Usuario - [Editando]",
                        component: UserForm
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ],
        beforeEnter(to, from, next) {
          console.log("Paso por aqui por administracion...");
          
          // Aqui se evalua para donde se redirige el flujo segun el usuario
          if (store.state.user.isLoggedIn) {
            if (store.state.user.type === "C") {
              next("/cliente");
            } else {
              if (store.state.user.data.tipo_Empleado === "V") {
                next("/comercial");
              } else {
                next();
              }
            }
          } else {
            next("/login")
          }
        }
      },
      {
        path: "/comercial",
        component: Dashboard,
        props: {
          fatherpath: "comercial"
        },
        redirect: to => redirect2(to, store),
        children: [
          {
            path: "/",
            name: "Dashboard Comercial", 
            component: HomeEmployee
          },
          {
            path: "coming-soon",
            name: "Proximamente!",
            component: PageComingSoon
          },
          {
            path: "archivo",
            name: "Archivo",
            component: {
              render (c) { return c('router-view') }
            },
            // redirect: to => redirect2(to, store),
            children: [
              {
                path: 'productos',
                name: 'Productos',
                component: ProductsEmployee
              },
              {
                path: 'directorio',
                name: 'Directorio',
                component: {
                  render (c) { return c('router-view') }
                },
                redirect: 'directorio',
                children: [
                  {
                    path: '/',
                    // name: 'Directorio',
                    component: DirectoryEmployee,
                  },
                  {
                    path: 'detalle',
                    name: 'Detalle',
                    component: DirectoryEmployeeItemView
                  },
                  {
                    path: 'agregar',
                    name: 'Agregar',
                    component: DirectoryEmployeeItemForm
                  },
                  {
                    path: 'editar',
                    name: 'Editar',
                    component: DirectoryEmployeeItemForm
                  },
                  {
                    path: 'agregarContacto',
                    name: 'Agregar Contacto',
                    component: DependencyForm
                  },
                  { 
                    path: 'editarContacto', 
                    name:'Editar Contacto', 
                    component: DependencyForm
                  }
                ]
              }
            ]
          },
          {
            path: 'mercadeo',
            name: 'Mercadeo',
            component: {
              render (c) { return c('router-view') }
            },
            redirect: to => redirect2(to, store),
            children: [
              {
                path: 'campanias',
                name: 'Campañas',
                component: {
                  render (c) { return c('router-view') }
                },
                redirect: to => redirect2(to, store),
                children: [
                  {
                    path: '/',
                    component: Campaigns
                  },
                  {
                    path: 'agregar',
                    name: 'Agregar Campaña',
                    component: CampaignForm
                  },
                  {
                    path: 'editar',
                    name: 'Editar Campaña',
                    component: CampaignForm
                  }
                ]
              },
              {
                path: 'oportunidades',
                name: 'Oportunidades',
                component: {
                  render (c) { return c('router-view') }
                },
                redirect: to => redirect2(to, store),
                children: [
                  {
                    path: '/',
                    component: Opportunities
                  },
                  {
                    path: 'agregar',
                    component: OpportunityForm
                  }
                ]
              },
              {
                path: 'seguimientos',
                name: 'Seguimientos',
                component: TrackingDocs
              }
            ]
          },
          {
            path: 'movimientos',
            name: 'Movimientos',
            component: {
              render (c) { 
                return c('router-view');
              }
            },
            // redirect: 'movimientos/contratosarrendamientos',
            children: [
              {
                path: 'garantias',
                name: 'Garantías',
                component: {
                  render(c) { return c('router-view') }
                },
                redirect: 'garantias',
                children: [
                  {
                    path: '/',
                    component: Warranties
                  },
                  {
                    path: 'seguimientos',
                    name: 'Seguimientos',
                    component: {
                      render(c) { return c('router-view') }
                    },
                    children:[
                      {
                        path: 'agregar',
                        component: WarrantyTracingForm
                      }
                    ]
                  }
                ]
              },
              {
                path: 'cotizaciones',
                name: 'Cotizaciones',
                component: {
                  render(c) { return c('router-view') }
                },
                redirect: 'cotizaciones',
                children: [
                  {
                    path: '/',
                    component: QuotesList
                  },
                  {
                    path: 'agregar',
                    name: 'Agregar Cotizacion',
                    component: QuoteForm
                  },
                  {
                    path: 'editar',
                    name: 'Editar Cotizacion',
                    component: QuoteForm
                  }
                ]
              },
              {
                path: 'pedidos',
                name: 'Pedidos',
                component: OrdersList
              },
              {
                path: 'facturasventa',
                name: 'Facturas Venta', 
                component: SellBills
              },
              {
                path: 'entregasmercancia',
                name: 'Entregas Mercancía', 
                component: WareDelivery
              },
              {
                path: "recepciondocumentoselectronicos",
                name: "Recepcion Documentos Electronicos",
                component: ReceptionElectronicDocuments,
                beforeEnter(to, from, next) {
                  store.state.user.data.tipo_Empleado === "A" ? next() : next({ path: "/sinacceso" })
                }
              }
            ]
          },
          {
            path: "consultas",
            name: "Consultas",
            component: {
              render (c) { return c("router-view") }
            },
            redirect: to => redirect2(to, store),
            children: [
              {
                path: "controlseguimientodocumentos",
                name: "Seguimiento de Documentos",
                component: DocumentsTrackingControl
              }
            ]
          },
          {
            path: 'indicadores',
            name: 'Indicadores',
            component: {
              render (c) { return c('router-view') }
            },
            redirect: to => redirect2(to, store),
            children: [
              {
                path: "dashboardproductos",
                name: "Dashboard de Productos",
                component: DashboardProducts
              },
              {
                path: "dashboardclientes",
                name: "Dashboard de Clientes",
                component: DashboardCustomer
              },
              {
                path: "dashboardventas",
                name: "Dashboard de Ventas",
                component: {
                  render(c) { return c("router-view") }
                },
                redirect: "dashboardventas",
                children: [
                  {
                    path: "/",
                    component: DashboardSales
                  },
                  {
                    path: "utilidadventasdocumentos",
                    name: "Utilidad de Ventas por Documentos",
                    component: DocumentSalesProfit
                  },
                  {
                    path: 'ejecucionpresupuestoscategorias',
                    name: 'Ejecución Presupuestos Ventas Categorias',
                    component: SalesBudgetExecution,
                    beforeEnter(to, from, next) {
                      if (store.state.user.data.tipo_Empleado === 'A' || store.state.user.data.tipo_Empleado === 'D') {
                        next()            
                      } else {
                        next({ path: '/sinacceso' })
                      }
                    }
                  }
                ]
              },
              {
                path: "dashboardcomerciales",
                name: "Dashboard de Comerciales",
                component: DashboardSellers
              },
              {
                path: "dashboardmercadeo",
                name: "Dashboard de Mercadeo",
                component: DashboardMarketing
              }
            ]
          },
          {
            path: 'ayudas',
            name: 'Ayudas',
            component: {
              render (c) { return c('router-view') }
            },
            redirect: to => redirect2(to, store),
            children: [
              {
                path: "acerca",
                name: "Acerca de",
                component: About
              }
            ]
          }
        ],
        beforeEnter(to, from, next) {
          if (store.state.user.isLoggedIn) {
            if (store.state.user.type === 'C') {
              next('/cliente')            
            } else {
              if (store.state.user.data.tipo_Empleado === "V") {
                next();
              } else {
                next("/administracion");
              }
            }
          } else {
            next('/login')
          }
        }
      },
      {
        path: "/cambioclaveusuario",
        component: ChangePassword
      },
      {
        path: "/panellogistica",
        component: DashboardLogistics
      },
      {
        path: '/solicitudgarantia',
        component: WarrantyRequestForm,
      },
      {
        path: '/seguimientopedido',
        component: OrderTracking,
      },
      {
        path: '/aceptacioncotizacion',
        component: QuoteApproval
      },
      {
        path: "/actualizaciondatoscliente",
        component: UpdateDirectory
      },
      {
        path: '/sinacceso',
        component: AccessDenied
      },
      {
        path: '/404',
        name: 'notFound',
        component: Page404
      }
  ]
}

export default routes;

const redirect2 = (to, store) => {
  const routesModel = store.state.user.data.routesAccessModel;

  return chooseFirstChild(to, to.matched, routesModel);
};

const chooseFirstChild = (to, pathChain, routesAccessModel) => {
  // console.log(pathChain, to, routesAccessModel)
  if (pathChain.length > 1) {
    // console.log('?')
    const headChain = pathChain.splice(0, 1);
    // console.log(headChain[0], pathChain)
    const headChildren = routesAccessModel.find(
      (route) => route.path === headChain[0].path
    );
    // console.log(headChildren)
    return chooseFirstChild(to, pathChain, headChildren.children);
  } else {
    const foundChild = routesAccessModel.find(
      (route) => route.path === to.path
    );
    // console.log(foundChild)
    return foundChild.children ? foundChild.children[0].path : foundChild.path;
  }
};
